import { ProSegment } from "@/features/dashboard/ui/pro-segment";
import { cn } from "@/lib/cn";
import { type ProThemePreference, useProThemeStore } from "@/stores/pro-theme";

function ProThemeSwitch() {
  const preference = useProThemeStore((state) => state.preference);
  const setPreference = useProThemeStore((state) => state.setPreference);

  return (
    <div className="space-y-1.5">
      <span className="block px-2 font-mono text-[9px] font-medium uppercase tracking-[0.14em] text-pro-text-faint">
        Appearance
      </span>
      <ProSegment
        aria-label="Color theme"
        className={cn("w-full [&>label]:flex-1 [&>label]:justify-center")}
        options={[
          { value: "dark", label: "Dark" },
          { value: "light", label: "Light" },
          { value: "system", label: "Auto" },
        ]}
        value={preference}
        onChange={(value) => setPreference(value as ProThemePreference)}
      />
    </div>
  );
}

export { ProThemeSwitch };
